/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createClone } from '../../factoriesAny.js';
export var cloneDependencies = {
  typedDependencies,
  createClone
};